import { commonEnvironments } from './environment.common';

export const environment = {
  production: true,
  baseUrls: commonEnvironments.prodBaseUrls,
  ...commonEnvironments,
};
